<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="isOem()" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-modular-quick-ship-system-inputs (valueChanged)="validateAndRateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()"
        (systemTypeChanged)="systemTypeChanged()">
      </app-modular-quick-ship-system-inputs>
      <app-indoor-air-quality (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-indoor-air-quality>
      <app-direct-drive-performance-input (valueChanged)="validateAndRateUnit()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-input>
      <app-direct-drive-performance-results [selectionEntities]="selectionEntities()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-results>
      <app-modular-quick-ship-mechanical-connections [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()" [invalidEntities]="invalidEntities()"
        [imagePrefix]="getImagePrefix()" (valueChanged)="validateUnit()">
      </app-modular-quick-ship-mechanical-connections>
      <app-modular-quick-ship-controls [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-quick-ship-controls>
      <app-modular-quick-primary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-quick-primary-valve-package>
      <app-modular-quick-secondary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-quick-secondary-valve-package>
      <app-modular-cabinet-features [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-cabinet-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
